<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import FallbackAvatar from '@/components/ui/FallbackAvatar'

export default {
  name: 'AppBar',
  components: {
    FallbackAvatar,
  },
  props: {
    barBgColor: {
      default: 'main-darken-5',
      type: String,
    },
    logoText: String,
    user: Object,
  },
  data() {
    return {
      isApp: false,
      showBackButton: false,
    }
  },
  computed: {
    ...mapState('auth', [
      'location',
      'settings',
    ]),
    getLogo() {
      return this.settings && this.settings.base_options && this.settings.base_options.show_company_logo &&
        this.location && this.location.image ?
          this.location.image :
          this.customerConfig.images.logo
    },
  },
  created() {
    if (!window.appInterval) {
      window.appInterval = null
    }
    clearInterval(window.appInterval)
    window.customerConfig = this.customerConfig
    window.appMenuComponent = this
    window.appInterval = setInterval(function() {
      const app = document.querySelector('html').getAttribute('data-app')
      window.appMenuComponent.isApp = Boolean(app && app === 'true')
      const button = window.customerConfig.backButton
      window.appMenuComponent.showBackButton = Boolean(
        button &&
        (button === true ||
         (button === 'app' && window.appMenuComponent.isApp)),
      )
    }, 200)
  },
  methods: {
    goBack() {
      window.history.back()
    },
  },
}
</script>
